exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".su{text-align:left}.report{padding-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/GuanKiann/Su/Su.css
// module id = 655
// module chunks = 0